import { useRedux } from "shared/lib/useRedux"

interface UseProjectRequestStateProps {
  projectID: string | null | undefined
}

export function useProjectRequestMonitor({
  projectID
}: UseProjectRequestStateProps) {
  const { isUpdatingChildren } = useRedux(({ request }) => ({
    isUpdatingChildren: projectID
      ? request.requests.PROJECTS[projectID]?.CREATE_PRODUCT_POSITION.length >
          0 ||
        request.requests.PROJECTS[projectID]?.DELETE_PRODUCT_POSITION.length >
          0 ||
        request.requests.PROJECTS[projectID]?.UPDATE_PRODUCT_POSITION_POSITION
          .length > 0 ||
        request.requests.PROJECTS[projectID]?.CREATE_ROOM.length > 0 ||
        request.requests.PROJECTS[projectID]?.DELETE_ROOM.length > 0 ||
        request.requests.PROJECTS[projectID]?.DUPLICATE_ROOM.length > 0 ||
        request.requests.PROJECTS[projectID]?.UPDATE_ROOM.length > 0 ||
        request.requests.PROJECTS[projectID]?.CREATE_FAVORITE.length > 0
      : undefined
  }))

  return {
    isUpdatingChildren: !!isUpdatingChildren
  }
}
